import { render, staticRenderFns } from "./grzx.vue?vue&type=template&id=0a9370d9&scoped=true"
import script from "./grzx.vue?vue&type=script&lang=js"
export * from "./grzx.vue?vue&type=script&lang=js"
import style0 from "./grzx.vue?vue&type=style&index=0&id=0a9370d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9370d9",
  null
  
)

export default component.exports